/**
 * OrderMixin
 */

export const OrderMixin = {
  name: 'OrderMixin',

  data: () => {
    return {};
  },

  methods: {
    getObjStrDueTime(dueTime) {
      const dtDueTime = new Date(dueTime);
      const strDueYear = `${dtDueTime.getFullYear()}`;
      const dueMonth = dtDueTime.getMonth() + 1;
      const strDueMonth = `${dueMonth < 10 ? '0' : ''}${dueMonth}`;
      const dueDate = dtDueTime.getDate();
      const strDueDate = `${dueDate < 10 ? '0' : ''}${dueDate}`;
      const dueHour = dtDueTime.getHours();
      const strDueHour = `${dueHour < 10 ? '0' : ''}${dueHour}`;
      const dueMinute = dtDueTime.getMinutes();
      const strDueMinute = `${dueMinute < 10 ? '0' : ''}${dueMinute}`;
      const dueSecond = dtDueTime.getSeconds();
      const strDueSecond = `${dueSecond < 10 ? '0' : ''}${dueSecond}`;
      return {
        strDueYear,
        strDueMonth,
        strDueDate,
        strDueHour,
        strDueMinute,
        strDueSecond,
      };
    },

    makeCpaGoodsDetailName(name) {
      let _str_ = '';
      if (name.indexOf('|')) {
        const arr = name.split('|');
        for (let i = 0, l = arr.length; i < l; i++) {
          _str_ += '<p>' + arr[i] + '</p>';
        }
      } else {
        _str_ = name;
      }
      return _str_;
    },
  },
};

export default OrderMixin;
